"use client";

import { Locale, setCurrentLocale } from "@/lib/localization";
import { Context, createContext, useContext } from "react";

export interface LocaleContextValue {
    locale: Locale;
    dir: "rtl" | "ltr";
}

const LocaleContext = createContext<LocaleContextValue | undefined>(undefined);

export const useLocale = () => {
    const context = useContext(
        LocaleContext as Context<LocaleContextValue | undefined>
    );
    if (!context) {
        throw new Error("useLocale must be used within a LocaleContext");
    }
    return context;
};

export interface LocaleProviderProps {
    children: React.ReactNode;
    locale: Locale;
    dir: "rtl" | "ltr";
}

export const LocaleProvider: React.FunctionComponent<LocaleProviderProps> = ({
    children,
    locale,
    dir,
}) => {
    setCurrentLocale(locale);

    return (
        <LocaleContext.Provider value={{ locale, dir }}>
            {children}
        </LocaleContext.Provider>
    );
};
